import styled from "styled-components";

const StackList = styled.ul<{cursor?: string}>`
	display: flex;
	font-size: 14px;
	color: var(--gray-color);
	align-items: center;

	li {
		cursor: ${props => (props.cursor ? "pointer" : "auto")};
	}
`;

export default StackList;
